module.exports = __webpack_public_path__ + "static/media/oportunidades_lines.c80fe3a2.png";